import api from "./api";

export type AnexoTipo = "imagem" | "audio" | "video" | "documento";

export interface ProjetoAnexo {
  id: string;
  projetoId: string;
  pastaId: string | null;
  tipo: AnexoTipo;
  url: string;
  nomeOriginal: string;
  mimeType: string;
  tamanhoBytes: number;
  descricao: string | null;
  visivelParaCliente: boolean;
  criadoPor: string;
  criadoEm: string;
}

export interface ProjetoPasta {
  id: string;
  projetoId: string;
  nome: string;
  paiId: string | null;
  ordem: number;
  criadoPor: string | null;
  criadoEm: string;
  atualizadoEm: string;
}

export async function listarAnexosProjeto(projetoId: string) {
  const r = await api.get(`/projetos/${projetoId}/anexos`);
  return r.data.data as ProjetoAnexo[];
}

export async function uploadAnexoProjeto(projetoId: string, file: File | Blob, opts?: { visivelParaCliente?: boolean; descricao?: string; nomeOriginal?: string; pastaId?: string | null }) {
  const fd = new FormData();
  fd.append("file", file, opts?.nomeOriginal || (file as File).name || "anexo");
  if (opts?.visivelParaCliente !== undefined) fd.append("visivelParaCliente", String(opts.visivelParaCliente));
  if (opts?.descricao) fd.append("descricao", opts.descricao);
  if (opts?.pastaId) fd.append("pastaId", opts.pastaId);
  const r = await api.post(`/projetos/${projetoId}/anexos`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data.data as ProjetoAnexo;
}

export async function atualizarAnexoProjeto(projetoId: string, anexoId: string, dados: { visivelParaCliente?: boolean; descricao?: string; pastaId?: string | null }) {
  const r = await api.patch(`/projetos/${projetoId}/anexos/${anexoId}`, dados);
  return r.data.data as ProjetoAnexo;
}

export async function deletarAnexoProjeto(projetoId: string, anexoId: string) {
  await api.delete(`/projetos/${projetoId}/anexos/${anexoId}`);
}

// === Pastas ===

export async function listarPastasProjeto(projetoId: string) {
  const r = await api.get(`/projetos/${projetoId}/pastas`);
  return r.data.data as ProjetoPasta[];
}

export async function criarPastaProjeto(projetoId: string, dados: { nome: string; paiId?: string | null }) {
  const r = await api.post(`/projetos/${projetoId}/pastas`, dados);
  return r.data.data as ProjetoPasta;
}

export async function atualizarPasta(pastaId: string, dados: { nome?: string; paiId?: string | null; ordem?: number }) {
  const r = await api.patch(`/projetos/pastas/${pastaId}`, dados);
  return r.data.data as ProjetoPasta;
}

export async function deletarPasta(pastaId: string) {
  await api.delete(`/projetos/pastas/${pastaId}`);
}
